import { useNavigate as _useNavigate } from "react-router-dom";

export default function useNavigate() {
  const _navigate = _useNavigate();

  const navigate = (to, params = {}, remove = [], options = {}) => {
    const currentSearch = window.location.search;
    const queryParams = new URLSearchParams(currentSearch);

    console.log('[useNavigate] Current search:', currentSearch);
    console.log('[useNavigate] Navigating to:', to);
    console.log('[useNavigate] Params to add:', params);

    for (const key of remove) {
      queryParams.delete(key);
    }

    for (const key in params) {
      queryParams.set(key, params[key]);
    }

    const searchString = queryParams.toString();
    console.log('[useNavigate] Final search string:', searchString);

    _navigate({
      pathname: to,
      search: searchString ? `?${searchString}` : ''
    }, options);
  }

  return {
    navigate
  };
}